/**
 * /devhub/system-map — System map (operator). Surface Layer (/01). REQ-001.91 Phase 3.
 * Live operator panel (DevHubSystemMapPanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubSystemMapPanel } from '../features/control-plane/DevHubSystemMapPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/system-map')({ component: SystemMapPage });

function SystemMapPage() {
  return (
    <DevHubPanelPage
      title="System map"
      subtitle="Capability registry — the platform live system map."
      status={{ label: 'live', live: true }}
    >
      <DevHubSystemMapPanel />
    </DevHubPanelPage>
  );
}
